/**
 * @file 发送给app的数据
 * @author liudy
 * @see http://api.umucdn.cn/project/86/wiki
 */

import umuWebview from '@umu/umu-webview';
import { SendMsgType } from '@umu/umu-types';

export interface ISendMsgToAppData {
    type: SendMsgType;
    data?: {
        info?: { [prop: string]: any };
        [prop: string]: any;
    };
}

export interface IInitMsgToAppData {
    page: string; // 页面名称
    route?: string; // 前端路由
    info?: { [prop: string]: any };
}

export function sendMsgToApp(type: SendMsgType, data: { [prop: string]: any }) {
    const params = {
        type,
        data,
    };
    // 发送到 app
    if (umuWebview.UA_INFO.isUMUWebview && umuWebview.isVersionLargerThan('3.4.8')) {
        console.log('sendMsgToApp' + params);
        umuWebview.callHandler('sendMsgToApp', params);
    }
}

export function initMsgToApp(data: IInitMsgToAppData) {
    sendMsgToApp(SendMsgType.initAppData, data);
}
